<label class="pr-input">
  @if (label) {
    <span class="pr-input-label d-flex"
      >{{ label }}
      @if (
        required ||
        (formControl &&
          formControl.validator &&
          formControl.validator({}) &&
          formControl.validator({}).required)
      ) {
        <em>*</em>
      }
      @if (tooltipButton) {
        <pr-icon
          class="tooltip-icon"
          name="sp-tooltip-icon"
          width="16"
          viewBoxWidth="18"
          viewBoxHeight="18"
          [tooltip]="tooltipButton"
        ></pr-icon>
      }
    </span>
  }
  <span
    class="pr-input-control"
    [ngClass]="{
      'is-invalid': derrors && formControl?.errors,
      'has-value': highlightOnValue && hasValue,
      'has-focus': highlightOnFocus && hasFocus,
    }"
    prLoader
    [loading]="loading"
    [tooltip]="suggestionTooltip"
    containerClass="helper success_colored"
    #suggestionTooltipTrigger
    triggers=""
    (focusin)="hasFocus = true"
    (focusout)="hasFocus = false"
    (input)="onInputEvent($event)"
  >
    <ng-content></ng-content>
    @if (suffix) {
      <span class="pr-input-suffix">{{ suffix }}</span>
    }
    <pr-errors
      [maskErrorMessage]="maskError"
      [phoneMask]="phoneMask"
      [derrors]="derrors"
      [control]="control || formControl"
    ></pr-errors>
  </span>
  <ng-content select="[subLabel]"></ng-content>
</label>

<ng-template #suggestionTooltip>
  <div
    class="d-flex"
    [ngClass]="customSuggestionButton.children.length ? 'flex-col' : ''"
  >
    <div #customSuggestionText [hidden]="!customSuggestionText.children.length">
      <ng-content select="[suggestion]"></ng-content>
    </div>
    @if (!customSuggestionText.children.length) {
      <ng-container #defaultSuggestionText>
        Suggestion : {{ suggestion }}
      </ng-container>
    }
    <div
      class="d-flex gap-xs flex-wrap"
      #customSuggestionButton
      [hidden]="!customSuggestionButton.children.length"
    >
      <ng-content select="[suggestionButton]"></ng-content>
    </div>
    @if (!customSuggestionButton.children.length) {
      <ng-container #defaultSuggestionButton>
        <button (click)="suggestionClicked.emit($event)" type="button">
          OK
        </button>
      </ng-container>
    }
  </div>
</ng-template>
